import 'maplibre-gl/dist/maplibre-gl.css'
import { useCallback, useState } from 'react'
import type { ViewStateChangeEvent } from 'react-map-gl/maplibre'
import Map, { NavigationControl } from 'react-map-gl/maplibre'
import type { Device } from '../../types/device.types'
import DeviceMarker from './DeviceMarker'
import MapEmptyState from './MapEmptyState'

interface DeviceMapProps {
  device: Device | undefined
}

const MAP_STYLE = 'https://tiles.openfreemap.org/styles/liberty'

const DEFAULT_VIEW = {
  longitude: 0,
  latitude: 20,
  zoom: 18,
}

export default function DeviceMap({ device }: DeviceMapProps) {
  const geo = device?.geolocation ?? null
  const geoKey = geo ? `${geo.lat},${geo.lon}` : 'none'

  const [viewState, setViewState] = useState(() =>
    geo ? { longitude: geo.lon, latitude: geo.lat, zoom: 18 } : DEFAULT_VIEW
  )

  const onMove = useCallback((evt: ViewStateChangeEvent) => {
    setViewState(evt.viewState)
  }, [])

  return (
    <div style={{ position: 'absolute', inset: 0 }}>
      <Map
        key={geoKey}
        {...viewState}
        onMove={onMove}
        mapStyle={MAP_STYLE}
        style={{ width: '100%', height: '100%' }}
        minZoom={2}
        maxZoom={18}
        attributionControl={false}
      >
        <NavigationControl position="bottom-left" />
        {device?.geolocation && (
          <DeviceMarker
            lat={device.geolocation.lat}
            lon={device.geolocation.lon}
            isOnline={device.isOnline}
          />
        )}
      </Map>
      {device && !device.geolocation && <MapEmptyState />}
    </div>
  )
}
